import fetch, { type Response } from 'node-fetch';

export default async (
  message: string,
  chatID: string = process.env.TG_CHAT_ID as string,
  token: string = process.env.TG_BOT_TOKEN as string,
): Promise<Response> => {
  const url = `https://api.telegram.org/bot${token}/sendMessage?chat_id=${chatID}&parse_mode=html&text=${encodeURIComponent(message)}`;
  return fetch(url);
};
